import { render, staticRenderFns } from "./DsSearch.vue?vue&type=template&id=16aa967d&scoped=true&"
import script from "./DsSearch.vue?vue&type=script&lang=js&"
export * from "./DsSearch.vue?vue&type=script&lang=js&"
import style0 from "./DsSearch.vue?vue&type=style&index=0&id=16aa967d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa967d",
  null
  
)

export default component.exports